import html2canvas from "html2canvas";
import { toast } from "react-toastify";

/**
 * Copia um elemento DOM como imagem para a área de transferência.
 * @param {string} elementId - ID do elemento a ser capturado.
 */
export async function copyElementToClipboard(elementId) {
  const el = document.getElementById(elementId);
  if (!el) {
    console.warn(`Elemento "${elementId}" não encontrado.`);
    return;
  }

  try {
    const canvas = await html2canvas(el, {
      scale: 2,
      useCORS: true,
      logging: false,
    });

    // Converte para blob (necessário para o Clipboard API)
    canvas.toBlob(async (blob) => {
      if (!blob) return;

      try {
        await navigator.clipboard.write([
          new ClipboardItem({ "image/png": blob })
        ]);

        toast.success("Imagem copiada para a área de transferência!")
      } catch (err) {
        console.error("Erro ao copiar imagem:", err);
      }
    }, "image/png");

  } catch (err) {
    console.error("Erro ao capturar imagem:", err);
  }
}
